export default function PageHero({ overline, title, subtitle, image, testid }) {
  return (
    <section
      data-testid={testid || "page-hero"}
      className="relative bg-[#0B2341] text-white overflow-hidden"
    >
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B2341] via-[#0B2341]/85 to-[#0B2341]/60" />
        </>
      )}
      <div className="relative container-corp py-24 md:py-32">
        {overline && <div className="overline mb-5">{overline}</div>}
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-lg text-white/75 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
        <div className="gold-line mt-10" />
      </div>
    </section>
  );
}
